module.exports = __webpack_public_path__ + "img/140.497573e1.jpg";